export const SAVE_WITH_US = 'save_with_us'
export const ACCEPT_SAVE_WITH_US = 'accept_save_with_us'
export const MY_CATALOG = 'my_catalog'
export const SAVING_ANALYSIS = 'saving_analysis'
export const ACTIVE_ORDERS = 'active_orders'
export const ORDER_HISTORY = 'order_history'
export const ORDERED_PRODUCTS = 'ordered_products'
export const NOT_SHIPPED = 'not_shipped'
export const COMPLETED_ORDERS = 'completed_orders'
export const PAYMENT_HISTORY = 'payment_history'
export const RETURNS = 'returns'
